<template>
  <div class="home">

    <div class="dv-swiper">
      <!--轮播图-->
      <WaimaiSwiper />
      <!--科室模块-->
      <div class="dv-ks">
        <div class="dv-ks-left-view">
          <div class="dv-ks-left-top">
            <div class="tv-ksjs">科室介绍</div>
            <div class="tv-ksjs-1">｜ 用心提供一流的医疗服务</div>
            <div class="tv-more-ks"
                 @click="godepartment">查看更多 + </div>
          </div>
          <div class="div-ks-scroll">
            <div class="dv-ks-view-1"
                 v-for="(item,index) in kslist"
                 style="margin-top: 8px;"
                 v-bind:key="index">
              <div class="tv-ks-left-ks">{{ item.name }}</div>
              <div class="tv-ziks-view">
                <div class="tv-zizks-name"
                     v-for="(items,indexs) in item.departList"
                     v-bind:key="indexs"
                     @click="onKsDs(item.id,items.id)">{{ items.name }}</div>

              </div>
            </div>

          </div>

        </div>

        <div class="dv-ks-right-view">
          <div class="dv-ks-right-top">
            <div class="tv-ksjs-r">院内公告</div>
            <div class="tv-ksjs-1"
                 style="color: #D6CCEF;">｜ 院内最新公告通知</div>
            <div class="tv-more"
                 @click="gonotice">查看更多 + </div>
          </div>
          <div class="div-ks-scroll">
            <div class="dv-ks-view-1"
                 style="margin-top: 15px;"
                 v-for="(item,index) in noticelists"
                 v-bind:key="index"
                 @click="noticeds(item.newsid)">
              <div class="div-kuai"></div>
              <div class="div-news-view">
                <div class="tv-news-title">{{ item.title }}</div>
                <div class="tv-news-time">{{ item.createdate }}</div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
    <!--医生护士模块-->
    <div class="dv-doctor">
      <div class="dv-doctor-top">
        <img src="../assets/images/icon_zj.png"
             class="img-zj">
        <div class="tv-byzj"
             :class="{'tv-byzjs':isdoctor}"
             @click="onSelectDoctor(isdoctor = true)">本院专家
          <div class="dc-xhx"
               v-if="isdoctor"></div>
        </div>
        <div class="tv-byzj"
             style="margin-left: 20px;">/</div>
        <img src="../assets/images/icon_hs.png"
             class="img-zjs"
             style="margin-left: 10px;">
        <div class="tv-byzj"
             :class="{'tv-byzjs':!isdoctor}"
             @click="onSelectDoctor(isdoctor = false)">白衣天使
          <div class="dc-xhx"
               v-if="!isdoctor"></div>
        </div>
        <div class="tv-doctor-tips">｜ 妙手两肩担道义 良医一心为病人</div>
      </div>

      <vue-seamless-scroll :data="doctorlists"
                           :class-option="defineScroll"
                           class="seamless">
        <div class="view-doctor-content">
          <div class="dv-doctor-item"
               v-for="(item,index) in doctorlists"
               v-bind:key="index">
            <img :src="item.fileUrl"
                 class="img-doctor-head">
            <div class="dv-doctor-content-bg">
              <div class="tv-doctor-name">{{item.name}}</div>
              <div class="tv-zhiwu"><span style="color: #333333;">职务：</span>{{ item.duties }}</div>
              <div class="tv-zhiwu"><span style="color: #333333;">专业：</span>{{ item.speciality }}</div>
            </div>
          </div>
        </div>
      </vue-seamless-scroll>

      <div class="tv-more-doctor"
           @click="DoctorMore">查看更多 + </div>

    </div>
    <!--新闻实事-->
    <div class="dv-ss-bg">
      <div class="dv-ss-left">
        <div class="dv-ss-left-l">
          <img src="../assets/images/icon_home_ht.png"
               class="img-ht">
          <div class="tv-xwss">新闻实事</div>
          <div class="tv-xwss-1">关注辽渔 了解实事</div>
          <div class="dv-xwss-select "
               :class="newsindex == 1 ? 'newsselect' : ''"
               @click="onNewsSelect('1')">
            医院新闻
            <div class="dc-xhx"
                 style="margin-top: 4px;"
                 v-show="newsindex == 1"></div>
          </div>
          <div class="dv-xwss-select"
               :class="newsindex == 2 ? 'newsselect' : ''"
               @click="onNewsSelect('2')">
            医院文化
            <div class="dc-xhx"
                 style="margin-top: 4px;"
                 v-show="newsindex == 2"></div>
          </div>
          <div class="dv-xwss-select"
               :class="newsindex == 3 ? 'newsselect' : ''"
               @click="onNewsSelect('3')">
            患者心声
            <div class="dc-xhx"
                 style="margin-top: 4px;"
                 v-show="newsindex == 3"></div>

          </div>
          <div class="tv-more-gx"
               @click="goNews()">查看更多 + </div>
        </div>
        <div class="dv-ss-left-2">
          <div class="dv-ss-left-list-bg"
               v-for="(item,index) in newslists"
               v-bind:key="index"
               @click="newsDs(item.newsid)">
            <el-image :src="item.fileUrl"
                      class="img-news-bg-home"
                      fit="cover"></el-image>
            <div class="dv-left-list-item-content">
              <div class="tv-news_titles">{{ item.title }}</div>
              <div class="tv-news_title-content">{{ item.introduce }}</div>
              <div class="dv-news-date-jusss">{{ item.createdate }}
                <img src="../assets/images/icon_home_right.png"
                     class="img-news-right">
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="dv-ss-right">
        <div class="dv-ss-right-top">
          <div class="tv-zp">舒适医疗</div>
          <div class="tv-zps">｜</div>
          <div class="tv-zps"
               style="margin-left: 10px;">让治病不必“忍忍”</div>
        </div>
        <div class="dv-comfor-bg">
          <comforswiper />

        </div>

      </div>

    </div>
    <!--医疗设备-->
    <div class="fl5 js-m delay1">
      <div class="dv-sb-item1 "
           :class="sbindex == 1 ? 'cur' : ''"
           @mouseover="MouseOver(1)">
        <!-- <img src="../assets/images/icon_home_sb1.png"
             class="img-home-sb-1"> -->
        <div class="dv-sb-1-left-content">
          <div class="tv-sb-title">医疗设备</div>
          <div class="tv-sb-title1">引领医疗科技 致力天下安康</div>
          <div class="tv-sb-items"
               v-for="(item,index) in devicelists"
               v-bind:key="index">
            <div class="dv-sb-fang"></div>
            <span class="tv-sb-item-title">{{ item.title }}</span>
          </div>

        </div>
        <div class="tv-more-g"
             @click="goDevice()">查看更多 + </div>
        <div class="dv-sb-1-right-content">
          <el-image :src="item.fileUrl"
                    class="img-home-sb-photo"
                    v-for="(item,index) in devicelists"
                    v-bind:key="index"
                    fit="cover"
                    v-show="sbindex === 1"></el-image>
        </div>
      </div>
      <div class="dv-sb-item2"
           :class="sbindex == 2 ? 'cur' : ''"
           @mouseover="MouseOver(2)">
        <!-- <img src="../assets/images/icon_home_sb2.png"
             class="img-home-sb-1"> -->
        <div class="dv-sb-1-left-content">
          <div class="tv-sb-title">荣誉资质</div>
          <div class="tv-sb-title1">获此殊荣，倍感荣幸</div>
          <div class="tv-sb-items"
               v-for="(item,index) in honorlists"
               v-bind:key="index">
            <div class="dv-sb-fang"></div>
            <span class="tv-sb-item-title">{{ item.title }}</span>
          </div>

        </div>
        <div class="tv-more-g"
             @click="goHonor()">查看更多 + </div>
        <div class="dv-sb-1-right-content">
          <div class="dv-sb-jiang-bg"
               v-for="(item,index) in honorlists"
               v-show="sbindex === 2"
               v-bind:key="index">
            <el-image :src="item.fileUrl"
                      fit="contain"
                      class="img-home-sb-photo-2"></el-image>
          </div>
        </div>
      </div>
      <div class="dv-sb-item3"
           :class="sbindex == 3 ? 'cur' : ''"
           @mouseover="MouseOver(3)">

        <!-- <img src="../assets/images/icon_home_sb3.png"
             class="img-home-sb-1"> -->
        <!-- <img src="../assets/images/icon_home_sb4.png"
             class="img-home-sb-2"> -->
        <div class="dv-sb-1-left-content">
          <div class="tv-sb-title">辽渔视频</div>
        </div>
        <div class="dv-voice-bg">
          <video :src="fileUrl"
                 autoplay="true"
                 loop="true"
                 preload="true"
                 class="video"
                 muted="muted"
                 controls></video>

        </div>
      </div>
    </div>
    <!--医院概况-->
    <div class="dv-gk-bg">
      <img src="../assets/images/icon_home_gk.png"
           class="icon-gk">
      <div class="dv-gk-content-bg">
        <div class="dv-gk-left">
          <div class="dv-yygk-title">
            医院概况
            <div class="dv-gk-titles">以人为本 生命至上</div>
          </div>
          <div class="dv-gk-content-bg-s">
            <div class="div-gk-yellow"></div>
            <div class="div-gk-c"
                 @click="gooverview(1)">{{ hospitaldetails.content_first }}</div>
          </div>
          <div class="dv-gk-content-bg-s">
            <div class="div-gk-yellow"></div>
            <div class="div-gk-c"
                 @click="gooverview(1)">{{ hospitaldetails.content_two }}</div>
          </div>

        </div>
        <div class="dv-gk-num-bg">
          <div class="div-bg-num-item"
               v-for="(item,index) in hospitaldetails.list"
               v-bind:key="index">
            <div class="dv-bg-num-title">
              <div class="dv-gk-num">{{ item.content_num }}<span style="font-size: 18px;margin-left: 5px;">{{ item.content_unit }}</span></div>
            </div>
            <div class="dc-gk-bottom-title">{{item.content_describe}}</div>
          </div>

        </div>
        <img src="../assets/images/icon_home_sb.png"
             class="img-sb">
      </div>
      <div class="dv-gk-heng">
        <div class="dv-gk-heng-title">关于辽渔医院，想了解更多？</div>

      </div>

    </div>
    <!--宣传-->
    <div class="dv-bottom-xc">
      <img src="../assets/images/icon_home_xc.png"
           class="img-xc">
      <div class="dv-bottom-sc-bg">
        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_1.png"
               class="img-bottom-1">
          <div class="tv-bottom-1">30+</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">有临床经验30年</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">专家坐诊</div>
        </div>

        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_2.png"
               class="img-bottom-2">
          <div class="tv-bottom-1">55+</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">高级职称专家</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">为首的医疗团队</div>
        </div>

        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_3.png"
               class="img-bottom-3">
          <div class="tv-bottom-1">7x24</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">每一天，无假日</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">迅速处理医疗突发状况</div>
        </div>

        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_4.png"
               class="img-bottom-4">
          <div class="tv-bottom-1">3+</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">医疗、生育、工伤保险</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">定点单位</div>
        </div>

        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_5.png"
               class="img-bottom-5">
          <div class="tv-bottom-1">24+</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">24小时</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">在线挂号</div>
        </div>

        <div class="dv-sc-item">
          <img src="../assets/images/icon_bottom_6.png"
               class="img-bottom-6">
          <div class="tv-bottom-1">1+</div>
          <div class="tv-bottom-1"
               style="margin-top: 10px;">始终如一，为您提供</div>
          <div class="tv-bottom-1"
               style="margin-top: 2px;">高质量医疗服务</div>
        </div>

      </div>

    </div>

  </div>
</template>
 
<script>
import WaimaiSwiper from '../components/swiper'
import comforswiper from '../components/comforswiper'

import vueSeamlessScroll from 'vue-seamless-scroll'  // vue2引入方式
import api from '../api/api'
const aes = require('../utils/aes.js')

export default {

  name: 'Home',
  components: {
    vueSeamlessScroll,
    WaimaiSwiper,
    comforswiper,


  },
  data () {
    return {
      seamlessScrollKey: 0,
      sbindex: 1,
      doctor: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      kslist: [{
        ksname: '临床内科',
        kschine: [{
          chinename: '康复医疗科'
        }, {
          chinename: '综合内科'
        }, {
          chinename: '心血管科'
        },
        ]
      }, {
        ksname: '临床外科',
        kschine: [{
          chinename: '妇科'
        }, {
          chinename: '产科'
        }, {
          chinename: '麻醉科'
        },
        ]
      }, {
        ksname: '医技科室',
        kschine: [{
          chinename: '药剂科'
        }, {
          chinename: '超生科'
        }, {
          chinename: '影像科'
        }, {
          chinename: '检验科'
        }, {
          chinename: '心电图科'
        }
        ]
      }, {
        ksname: '门急诊科室',
        kschine: [{
          chinename: '女性乳腺、肛肠门诊'
        }, {
          chinename: '疼痛门诊'
        }, {
          chinename: '急诊科'
        }, {
          chinename: '检验科'
        }, {
          chinename: '中医科'
        }, {
          chinename: '理疗科'
        }, {
          chinename: '眼耳鼻喉科'
        }, {
          chinename: '眼耳鼻喉科'
        }
        ]
      }, {
        ksname: '五大中心',
        kschine: [{
          chinename: '消化内镜中心'
        }, {
          chinename: '体检中心'
        }, {
          chinename: '血液净化中心'
        }
        ]
      }
      ],
      isdoctor: true,
      noticelists: [],//院内公告
      doctorlists: [],//医生 天使列表
      newslists: [],//医院新闻列表
      newsindex: 1,//1代表医院新闻 2代表医院文化 3代表患者心声
      recruitlists: [],//招聘信息列表
      devicelists: [],//医疗设备列表
      honorlists: [],//荣誉资质列表
      leaderlists: [],//领导团队列表
      hospitaldetails: '',//医院简介
      fileUrl: '',//视频

    }
  },
  computed: {
    defineScroll () {
      return {
        step: 2, // 数值越大速度滚动越快
        limitMoveNum: this.doctor.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created () {
    //科室列表
    this.getCategorylist()
    //院内公告
    this.noticelist()
    //本院专家
    this.doctorlist()
    //医院新闻列表
    this.newslist()
    //招聘信息列表
    this.recruitlist()
    //医疗设备列表
    this.devicelist()
    //荣誉资质
    this.honorlist()
    //领导团队列表
    this.leaderlist()
    //医院简介
    this.hospitaldetail()
    //视频
    this.homepagevideo()
  },
  methods: {
    //去往科室介绍
    godepartment () {
      this.$router.push({ path: '/department' })
    },
    //去往院内公告
    gonotice () {
      this.$router.push({ path: '/notice' })
    },
    //去往医疗设备
    goDevice () {
      this.$router.push({ path: '/device' })
    },
    //去往荣誉资质
    goHonor () {
      this.$router.push({ path: '/honor' })
    },
    //去往招聘信息
    gorecruit () {
      this.$router.push({ path: '/recruit' })
    },
    //去往领导团队
    gooverview (e) {
      if (e == '2') {
        this.$router.push({ path: '/overview', query: { type: 'team' } })
      } else {
        this.$router.push({ path: '/overview' })
      }

    },
    //去往新闻
    goNews () {
      this.$router.push({ path: '/news', query: { type: this.newsindex } })
    },
    MouseOver (index) {
      this.sbindex = index
    },
    //科室详情
    onKsDs (fid, zid) {
      console.log(fid)
      console.log(zid)
      this.$router.push({
        path: '/department',
        query: {
          fid: fid,
          zid: zid
        }
      })
    },
    //院内公告详情
    noticeds (id) {
      this.$router.push({
        path: '/noticeds',
        query: {
          id: id
        }
      })
    },
    //新闻详情
    newsDs (id) {
      this.$router.push({
        path: '/newsDs',
        query: {
          id: id,
          current: this.newsindex
        }
      })
    },
    //招聘信息详情
    recruitDs (id) {
      this.$router.push({
        path: '/recruitDs',
        query: {
          id: id
        }
      })
    },
    //医生专家 天使切换
    onSelectDoctor () {

      if (this.isdoctor) {
        this.doctorlist()
      } else {
        this.nurselist()
      }

    },
    DoctorMore () {
      this.$router.push({
        path: '/expert',
        query: {
          isdoctor: this.isdoctor
        }

      })
    },
    //新闻选择
    onNewsSelect (e) {
      this.newsindex = e
      switch (e) {
        case '1':
          this.newslist()
          break;
        case '2':
          this.culturelist()
          break;
        case '3':
          this.aspirationlist()
          break;

      }

    },
    //获取科室列表
    getCategorylist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 100
      }
      api.departcategorylist(parm).then((res) => {
        this.kslist = res.data.list
      })
    },
    //院内公告
    noticelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 4
      }
      api.noticelist(parm).then((res) => {
        this.noticelists = res.data.list
      })
    },
    //本院专家
    doctorlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 20,
        departid: ''
      }
      api.doctorlist(parm).then((res) => {
        this.doctorlists = res.data.list

      })
    },
    //天使列表
    nurselist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 20,
        departid: ''
      }
      api.nurselist(parm).then((res) => {
        this.doctorlists = res.data.list

      })
    },
    //医院新闻列表
    newslist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 3,

      }
      api.newslist(parm).then((res) => {
        this.newslists = res.data.list

      })
    },
    //医院文化列表
    culturelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 3,

      }
      api.culturelist(parm).then((res) => {
        this.newslists = res.data.list

      })
    },
    //患者心声列表
    aspirationlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 3,

      }
      api.aspirationlist(parm).then((res) => {
        this.newslists = res.data.list

      })
    },
    //招聘信息列表
    recruitlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 5,

      }
      api.recruitlist(parm).then((res) => {
        this.recruitlists = res.data.list

      })
    },
    //医疗设备列表
    devicelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 4,

      }
      api.devicelist(parm).then((res) => {
        this.devicelists = res.data.list

      })
    },
    //荣誉资质列表
    honorlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 4,

      }
      api.honorlist(parm).then((res) => {
        this.honorlists = res.data.list

      })
    },
    //领导团队列表
    leaderlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 2,

      }
      api.leaderlist(parm).then((res) => {
        this.leaderlists = res.data.list

      })
    },
    //医院简介
    hospitaldetail () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 2,

      }
      api.hospitaldetail(parm).then((res) => {
        this.hospitaldetails = res.data

      })
    },
    //医院简介
    homepagevideo () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 2,

      }
      api.homepagevideo(parm).then((res) => {
        this.fileUrl = res.data.fileUrl

      })
    },
  }


}
</script>

<style scoped>
.main-color {
  color: #5f66cb;
}

.main-pink {
  color: #ed4870;
}

.main-yellow {
  color: #fbb03b;
}

.home {
  padding-top: 140px;
}

/* 第二部分 */
.section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 142.18px 0;
}

.s-img {
  width: 520px;
  margin-right: 27px;
}

.s-content {
  text-align: left;
}

.sc-title {
  font-size: 48px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  line-height: 36px;
}

.sc-des {
  font-size: 14px;
  font-family: Alibaba PuHuiTi;
  font-weight: 300;
  line-height: 24px;
}

.sc-tip {
  font-size: 18px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  line-height: 29px;
}

/* 第三部分 */
.section-two {
  height: 400px;
  background-color: #f7f8e5;
}

.stc-item {
  display: flex;
  width: 220px;
  height: 220px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  background-color: #ed4870;
  margin-right: 67px;
}

.stc-item:last-child {
  margin-right: 0;
}

.stc-item-two {
  background-color: #ffaf29;
}

.stc-item-three {
  background-color: #7078e3;
}

.stci-img {
  width: 53.34px;
}

.stci-txt {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #ffffff;
}

.s-img-t {
  width: 562px;
  margin-left: -88px;
}

/* 第四部分 */
.section-three {
  padding: 127.22px 0 391px;
  background-color: #fcf7e4;
  z-index: 2;
}

.s-img-three {
  width: 230px;
}

.st-icons {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%) translateY(50%);
  width: 780.01px;
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(152, 152, 152, 0.1);
  border-radius: 20px;
  background-image: url(../assets/images/icon_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
}

.sti-items {
  padding: 106px 108px;
}

.stii-items {
  margin-bottom: 59.78px;
}

.stii-items:last-child {
  margin-bottom: 0;
}

.stiit-item {
  line-height: 0;
  margin-right: 60px;
}

.stiit-item:last-child {
  margin-right: 0;
}

.stiiti-img {
  width: 96px;
}

.stiiti-txt {
  display: block;
  font-size: 24px;
  color: #707070;
  line-height: 33px;
  margin-top: 16.32px;
}

.section-five {
  position: relative;
  /* height: 769px; */
  height: 450px;
}

.sf-btn {
  top: 411px;
}

/* 第六部分 */
.section-six {
  position: relative;
  height: 355px;
  background-color: #fcf7e4;
}

/* 圆 */
.s-circle1 {
  position: absolute;
  right: -6.4375rem;
  top: 8.4375rem;
  width: 34.875rem;
  height: 34.875rem;
  background: linear-gradient(180deg, #ffa7ad 0%, #ff3d4b 100%);
  border-radius: 50%;
  opacity: 0.06;
}

.s-circle2 {
  position: absolute;
  left: -12.0625rem;
  top: -6.0625rem;
  width: 23.875rem;
  height: 23.875rem;
  background: linear-gradient(180deg, #cacafc 0%, #9f89ff 100%);
  border-radius: 50%;
  opacity: 0.19;
}

.s-circle3 {
  position: absolute;
  right: 15.625rem;
  bottom: 13.75rem;
  width: 9.375rem;
  height: 9.375rem;
  background: linear-gradient(180deg, #75ddda 0%, #1cb5a1 100%);
  border-radius: 50%;
  opacity: 0.14;
}

.s-circle4 {
  position: absolute;
  left: -0.9375rem;
  top: 5.25rem;
  width: 25rem;
  height: 25rem;
  background: linear-gradient(
    180deg,
    #f56800 0%,
    #f56d05 5%,
    #f78926 44%,
    #f99b3a 77%,
    #f9a141 100%
  );
  border-radius: 50%;
  opacity: 0.2;
}

/* 六边形 */
.six-border {
  position: absolute;
  bottom: 58%;
  right: 0;
  width: 12.5rem;
  height: 21.65rem;
  margin: 12.5rem auto;
  background-color: rgba(92, 171, 255, 0.18);
  transform: rotate(30deg);
}

.six-border:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  right: 12.5rem;
  border-width: 10.825rem 6.25rem;
  border-style: solid;
  border-color: transparent rgba(92, 171, 255, 0.18) transparent transparent;
}

.six-border:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  left: 12.5rem;
  border-width: 10.825rem 6.25rem;
  border-style: solid;
  border-color: transparent transparent transparent rgba(92, 171, 255, 0.18);
  top: 0;
}

/* 圆角三角形 */
.circle-tri {
  position: absolute;
  left: 8.625rem;
  top: -3.125rem;
  width: 0;
  height: 0;
  transform: rotate(-150deg);
  margin: 9.375rem auto;
  border-left: 7.5rem solid transparent;
  border-right: 7.5rem solid transparent;
  border-bottom: 12.9984375rem solid rgba(89, 170, 255, 0.2);
}
/* 新版 */
.si-over {
  width: 311px;
  margin-top: -75px;
  transform: translateX(-85px);
}
.s-img-new {
  width: 264px;
  margin-left: 90px;
}
.sin-o {
  width: 335px;
  margin-top: -26px;
  transform: translateX(-128px);
}
.dv-top-view {
  background: url("../assets/images/icon_home_1.png");
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.tv-top-left {
  font-size: 20rpx;
  font-family: STZhongsong, STZhongsong-Regular;
  font-weight: 400;
  text-align: left;
  margin-left: 20%;
  color: #ffffff;
}
.dv-top-right-view {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20%;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
}
.img-top-phone {
  width: 150px;
  height: 28px;
  margin-right: 10px;
}
.dv-swiper {
  position: relative;
  height: 1010px;
}
.dv-ks {
  position: absolute;
  bottom: 0;
  margin-left: 300px;
  width: calc(100% - 600px);
  height: 390px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
}
.dv-ks-left-view {
  width: 60%;
  background: #edf0f8;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dv-ks-left-top {
  position: relative;
  display: flex;
  flex-direction: row;
  height: 70px;
  background: url("../assets//images//icon_home_2.png");
}
.dv-ks-right-view {
  width: 40%;
  background: #edf0f8;
  height: 100%;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
}
.dv-ks-right-top {
  position: relative;
  display: flex;
  flex-direction: row;
  height: 70px;
  background: url("../assets//images//icon_home_3.png");
}
.tv-ksjs {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  margin-left: 30px;
  margin-top: 24px;
  color: #593e2a;
}
.tv-ksjs-r {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  margin-left: 30px;
  margin-top: 24px;
  color: #ffffff;
}
.tv-ksjs-1 {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  margin-left: 30px;
  margin-top: 26px;
  text-align: left;
  color: #806857;
}
.tv-more {
  position: absolute;
  right: 25px;
  width: 110px;
  top: 16px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #c0b1e8;
  font-size: 16px;
  color: #c0b1e8;
}
.tv-more-ks {
  position: absolute;
  right: 25px;
  width: 110px;
  top: 16px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #b08a64;
  font-size: 16px;
  color: #8f6a4e;
}
.tv-more-g {
  width: 110px;
  margin-top: 40px;
  position: absolute;
  bottom: 20px;
  left: calc(50% - 55px);
  height: 40px;
  line-height: 40px;
  border: 2px solid #838f91;
  font-size: 16px;
  color: #838f91;
}
.tv-more-gx {
  width: 110px;
  margin-top: 40px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #c1cae4;
  font-size: 16px;
  color: #c1cae4;
}
.tv-mores {
  width: 110px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #ffffff;
  font-size: 16px;
  margin-top: 40px;
  color: #ffffff;
}
.div-ks-scroll {
  width: 100%;
  height: calc(100% - 100px);
  overflow-y: scroll;
  margin-top: 10px;
  scrollbar-color: #ff0000;
}
.dv-ks-view-1 {
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
}
.tv-ks-left-ks {
  width: 140px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-left: 20px;
  font-size: 18px;
  background: #e6d5b3;
}
.tv-ziks-view {
  width: calc(100% - 180px);
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.tv-zizks-name {
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  padding: 0 10px 0 10px;
  margin-bottom: 10px;
  /* background: #ffffff; */
  color: #b18641;
  margin-right: 30px;
}
.tv-zizks-name:hover {
  background-color: #ffffff;
}
.div-kuai {
  width: 10px;
  height: 10px;
  background: #dfa813;
  margin-top: 6px;
  margin-left: 20px;
}
.div-news-view {
  width: calc(100% - 80px);
  margin-left: 20px;
  display: flex;
  flex-direction: column;
}
.tv-news-title {
  font-size: 20px;
  text-align: left;
  color: #333333;
  letter-spacing: 0.5px;
}
.tv-news-time {
  font-size: 18px;
  text-align: left;
  color: #707070;
  margin-top: 5px;
  letter-spacing: 0.5px;
}
.tv-news-title:hover {
  color: #634d91;
  text-decoration: underline;
}
.dv-doctor {
  width: 100%;
  background: url("../assets/images/icon_home_doctor_bg.png");
  height: 600px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
  position: relative;
}
.dv-doctor-top {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  margin-left: 300px;
  position: relative;
}
.img-zj {
  width: 40px;
  height: 40px;
}
.img-zjs {
  width: 55px;
  height: 55px;
}
.tv-byzj {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  color: #8271ae;
  margin-top: 20px;
  margin-left: -10px;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.dc-xhx {
  width: 30px;
  height: 3px;
  margin-top: 5px;
  background: #8271ae;
}
.tv-byzjs {
  color: #8271ae;
}
.tv-doctor-tips {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #b5bccf;
  margin-left: 30px;
  margin-top: 22px;
}
.view-doctor-content {
  width: 100%;
  height: 350px;
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.dv-doctor-item {
  width: 250px;
  margin-right: 50px;
  height: 350px;
  position: relative;
}
.img-doctor-head {
  width: 150px;
  height: 150px;
  border-radius: 180px;
  position: absolute;
  left: calc(50% - 75px);
  z-index: 2;
  object-fit: cover;
}
.dv-doctor-content-bg {
  width: 100%;
  height: 280px;
  position: absolute;
  bottom: 0;
  z-index: 1;
  background: white;
  display: flex;
  flex-direction: column;
}

.tv-doctor-name {
  font-size: 24px;
  color: #333333;
  margin-top: 90px;
}
.tv-zhiwu {
  font-size: 18px;
  color: #767c8b;
  margin-top: 20px;
  width: 90%;
  margin-left: 5%;
  text-align: left;
}
.seamless {
  width: 100%;
}
.tv-more-doctor {
  position: absolute;
  right: calc(50% - 55px);
  width: 110px;
  bottom: 34px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #ffffff;
  font-size: 16px;
  color: #ffffff;
}
.dv-ss-bg {
  margin-left: 300px;
  width: calc(100% - 600px);
  height: 500px;
  margin-top: 14px;
  display: flex;
  flex-direction: row;
}
.dv-ss-left {
  width: 77%;
  height: 100%;
  background: #edf0f8;
  display: flex;
  flex-direction: row;
}
.dv-ss-left-l {
  width: 260px;
  height: 100%;
  align-items: center;
  background: #e3e7f4;
  position: relative;
  display: flex;
  flex-direction: column;
}
.img-ht {
  width: 200px;
  position: absolute;
  bottom: 0;
  height: 140px;
}
.tv-xwss {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  margin-top: 20px;
  margin-left: 20px;
  color: #333333;
}
.tv-xwss-1 {
  font-size: 18px;
  /* font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold; */
  text-align: left;
  margin-top: 4px;
  margin-left: 20px;
  color: #b5bccf;
  margin-bottom: 30px;
}
.dv-xwss-select {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  height: 50px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: center;
  color: #333333;
}
.dv-ss-left-2 {
  width: calc(100% - 300px);
  margin-left: 20px;
  padding-top: 10px;
  height: calc(100% - 20px);
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.dv-ss-left-list-bg {
  width: 100%;
  height: 140px;
  margin-bottom: 20px;

  display: flex;
  flex-direction: row;
}
.img-news-bg-home {
  width: 220px;
  height: 100%;
}
.dv-left-list-item-content {
  display: flex;
  flex-direction: column;
  width: calc(100% - 240px);
  margin-left: 20px;
  height: 100%;
}
.tv-news_titles {
  font-size: 19px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 10px;
  color: #333333;
  overflow: hidden; /* 确保内容超出容器时会被裁剪 */
  text-overflow: ellipsis; /* 使用省略号表示被裁剪的文本 */
  display: -webkit-box; /* 使用弹性盒子布局模型 */
  -webkit-line-clamp: 1; /* 限制在两行 */
  -webkit-box-orient: vertical; /* 垂直排列盒子 */
}
.tv-news_title-content {
  font-size: 18px;
  width: calc(100% - 20px);
  font-family: PingFang SC, PingFang SC-Semibold;
  /* font-weight: 600; */
  text-align: left;
  margin-top: 10px;
  color: #707070;
  overflow: hidden; /* 确保内容超出容器时会被裁剪 */
  text-overflow: ellipsis; /* 使用省略号表示被裁剪的文本 */
  display: -webkit-box; /* 使用弹性盒子布局模型 */
  -webkit-line-clamp: 2; /* 限制在两行 */
  -webkit-box-orient: vertical; /* 垂直排列盒子 */
}
.dv-news-date-jusss {
  font-size: 17px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  margin-top: 10px;
  color: #707070;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.img-news-right {
  width: 24px;
  margin-top: 10px;
  margin-right: 20px;
  height: 6px;
}
.tv-news_titles:hover {
  color: #634d91;
  text-decoration: underline;
}
.dv-ss-right {
  width: 23%;
  margin-left: 20px;
  background: #edf0f8;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
}
.img-ss {
  width: 100%;
  height: 300px;
  position: absolute;
  bottom: 0;
}
.dv-ss-right-top {
  width: 100%;
  height: 50px;
  background: linear-gradient(48deg, #e3e7f4 0%, #e5e8f2 41%, #d6dced 100%),
    #edf0f8;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.tv-zp {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  margin-left: 20px;
  text-align: left;
  color: #333333;
}
.tv-zps {
  font-size: 18px;
  /* font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold; */
  /* font-weight: 700; */
  text-align: left;
  margin-left: 30px;
  color: #b5bccf;
}

.dv-gk-bg {
  width: 100%;
  margin-top: 16px;
  height: 600px;
  position: relative;
  background: #edf0f8;
}
.icon-gk {
  position: absolute;
  left: 0;
  top: 0;
  width: 55%;
  height: 100%;
}
.dv-gk-content-bg {
  margin-left: 300px;
  width: calc(100% - 600px);
  height: 100%;
  display: flex;
  flex-direction: row;
}
.dv-gk-left {
  width: 50%;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
.dv-yygk-title {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
}
.dv-gk-titles {
  margin: 8px 0 0 30px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 400;
  text-align: left;
  color: #b5bccf;
}
.dv-gk-content-bg-s {
  width: 100%;
  height: fit-content;
  display: flex;
  margin-top: 50px;
  flex-direction: row;
}
.div-gk-yellow {
  width: 5px;
  margin-top: 10px;
  height: 5px;
  background: #dfa813;
}
.div-gk-c {
  width: calc(100% - 25px);
  margin-left: 20px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #60449a;
}
.div-gk-c:hover {
  text-decoration: underline;
}
.dv-gk-num-bg {
  width: 35%;
  height: fit-content;
  margin-top: 60px;
  display: flex;
  position: absolute;
  left: 300px;
  bottom: 180px;
  flex-direction: row;
  justify-content: space-around;
}
.dv-gk-num-bg::before {
  content: "";
  display: block;
}
.dv-gk-num-bg::after {
  content: "";
  display: block;
}
.div-bg-num-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dv-bg-num-title {
  display: flex;
  flex-direction: row;
}
.dv-gk-num {
  font-size: 36px;
  /* font-family: PingFang SC, PingFang SC-Semibold; */
  font-weight: 500;
  text-align: left;
  color: #60449a;
}
.dc-gk-bottom-title {
  font-size: 18px;
  /* font-family: PingFang SC, PingFang SC-Semibold; */
  font-weight: 400;
  text-align: left;
  margin-top: 10px;
  color: #767c8b;
}
.img-sb {
  height: calc(100% - 100px);
  margin-top: 50px;
  margin-left: 30px;
  z-index: 2;
  width: 40%;
}
.dv-gk-heng {
  bottom: 40px;
  position: absolute;
  left: 300px;
  width: calc(100% - 600px);
  background: #8271ae;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.img-xc {
  width: 100%;
  height: fit-content;
  position: absolute;
  bottom: 0;
  left: 0;
}
.dv-bottom-xc {
  width: 100%;
  height: 248px;
  position: relative;
}
.dv-sb-item1 {
  background: url("../assets/images/icon_home_hua_1.png");
  width: 24%;
  /* background-size: 100%; */
  height: 100%;
  position: relative;
  margin-right: 20px;
  overflow: hidden;
  transition: width 0.5s ease;
  object-fit: scale-down;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dv-sb-item2 {
  background: url("../assets/images/icon_home_hua_2.png");
  /* background: #e8f0f2; */
  width: 24%;
  height: 100%;
  position: relative;
  margin-right: 20px;
  overflow: hidden;
  transition: width 0.5s ease;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dv-sb-item3 {
  background: #e8f0f2;
  /* background: url("../assets/images/icon_home_hua_3.png"); */
  width: 24%;
  height: 100%;
  position: relative;
  margin-right: 20px;
  overflow: hidden;
  transition: width 0.5s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.delay1 {
  transition-delay: 0.1s !important;
}
.js-m {
  transform: translate(0, 30px);
  transition: all 0.8s cubic-bezier(0.79, -0.27, 0.21, 0.82);
}
.dv-sb-bg {
  display: flex;
  flex-direction: row;
  position: relative;
  flex-shrink: 0;
}
.fl5 {
  margin-left: 300px;
  width: calc(100% - 575px);
  height: 500px;
  /* flex-shrink: 0; */
  margin-top: -18px;
  display: flex;
  overflow-x: scroll;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 44px;
}
.cur {
  width: 48%;
}
.img-home-sb-1 {
  width: 50%;
  position: absolute;
  flex-shrink: 0;
  left: 0;
  bottom: 0;
}
.dv-sb-1-left-content {
  display: flex;
  margin: 20px;
  flex-shrink: 0;
  flex-direction: column;
}
.tv-sb-title {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
}
.tv-sb-title1 {
  font-size: 18px;
  /* font-family: PingFang SC, PingFang SC-Medium; */
  font-weight: 400;
  margin-top: 10px;
  text-align: left;
  margin-bottom: 40px;
  color: #96a2b4;
}
.tv-sb-items {
  display: flex;
  flex-direction: row;
  margin-top: 18px;
  align-items: center;
}
.dv-sb-fang {
  width: 8px;
  height: 8px;
  background: #dfa813;
}
.tv-sb-item-title {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  margin-left: 10px;
  color: #333333;
}
.dv-sb-1-right-content {
  width: 50%;
  margin-right: 20px;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  margin-top: 50px;
  height: calc(100% - 100px);
  flex-wrap: wrap;
}
.img-home-sb-photo {
  width: calc(50% - 20px);
  margin-left: 20px;
  flex-shrink: 0;
  height: calc(50% - 20px);
}
.dv-sb-jiang-bg {
  width: calc(50% - 20px);
  margin-left: 20px;
  height: calc(50% - 20px);
  background: url("../assets/images/icon_ho_di.png");
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-home-sb-photo-2 {
  width: calc(100% - 20px);

  height: calc(100% - 20px);
}
.img-home-sb-2 {
  position: absolute;
  bottom: 150px;
  left: 100px;
  width: 90px;
}
.dv-sb-3-right-content {
  width: 50%;
  margin-right: 20px;
  display: flex;
  height: 300px;
  flex-direction: row;
  margin-top: 10%;
  flex-wrap: wrap;
}
.dv-sb-jiang-bg-3 {
  width: calc(50% - 20px);
  margin-left: 20px;
  height: 300px;
  background: white;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.newsselect {
  color: #8271ae;
}
.dv-gk-heng-title {
  font-size: 22px;
  color: #ffffff;
  margin-left: 280px;
}
.dv-comfor-bg {
  width: 100%;
  /* height: calc(100% - 80px); */
}
.dv-voice-bg {
  width: 100%;
  height: 100%;
}
.video {
  width: 100%;
  height: 100%;
}

.dv-bottom-sc-bg {
  width: 100%;

  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  display: -webkit-flex;
  -js-display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.dv-bottom-sc-bg::before {
  content: "";
  display: block;
}
.dv-bottom-sc-bg::after {
  content: "";
  display: block;
}
.dv-sc-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.img-bottom-1 {
  width: 49px;
  height: 51px;
}
.img-bottom-2 {
  width: 64px;
  height: 51px;
}
.img-bottom-3 {
  width: 56px;
  height: 38px;
}
.img-bottom-4 {
  width: 47px;
  height: 51px;
}
.img-bottom-5 {
  width: 53px;
  height: 49px;
}
.img-bottom-6 {
  width: 52px;
  height: 52px;
}
.tv-bottom-1 {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 500;
  margin-top: 10px;
  text-align: center;
  color: #ffffff;
}
</style>
